import { Application } from "@hotwired/stimulus";
import AccordionController from "./controllers/accordion_controller";
import MasonryController from "./controllers/masonry_controller";
import TabsController from "./controllers/tabs_controller";
import LabelController from "./controllers/label_controller";
import TogglerController from "./controllers/toggler_controller";
import PopoverController from "./controllers/popover_controller";

window.Stimulus = Application.start();

Stimulus.debug = true;
Stimulus.register("accordion", AccordionController);
Stimulus.register("masonry", MasonryController);
Stimulus.register("tabs", TabsController);
Stimulus.register("label", LabelController);
Stimulus.register("toggler", TogglerController);

if (!CSS.supports("selector(:popover-open)")) {
  Stimulus.register("popover", PopoverController);
}
